<template>
  <div class="show-container">
    <div :id="id" style="height: 100%;" v-if="hasData"></div>
    <show-no-data v-else></show-no-data>
  </div>
</template>

<script>
  import eCharts from 'echarts'
  import 'echarts/theme/macarons'
  import analyseUtil from '../analyse-util'
  import ShowNoData from '../show-no-data'
  import {addResizeListener, removeResizeListener} from 'element-ui/src/utils/resize-event'
  export default {
    components: {
      ShowNoData
    },
    props: {
      data: {
        type: 'Object'
      }
    },
    name: 'radar-config',
    typeCode: '5',
    data() {
      return {
        id: analyseUtil.randomId(),
        myChart: {},
        options: {
          legend: {
            data: null
          },
          tooltip: {},
          grid: {
            containLabel: true
          },
          color: analyseUtil.COLORS,
          radar: {
            name: {
              textStyle: {
                color: '#333333',
                padding: [1, 1]
              }
            },
            indicator: null
          },
          series: [{
            type: 'radar',
            itemStyle: {
              normal: {
                opacity: 0.8
              }
            },
            data: null
          }]
        }
      }
    },
    mounted() {
      if (this.hasData) {
        this.loadChart()
        addResizeListener(this.$el, this.resizeListener)
      }
    },
    beforeDestroy() {
      if (this.hasData) {
        removeResizeListener(this.$el, this.resizeListener)
      }
    },
    computed: {
      hasNoZero: function () {
        let hasNoZero = false
        for (let i = 0; i < this.data.indicators.length; i++) {
          hasNoZero = this.data.indicators[i].max ? this.data.indicators[i].max !== 0 : false
          if (hasNoZero) {
            break
          }
        }
        return hasNoZero
      },
      hasData: function () {
        return this.data.series && this.data.series.length > 0 && this.data.indicators && this.data.indicators.length > 0 && this.hasNoZero
      }
    },
    methods: {
      resizeListener: function () {
        this.$nextTick(() => {
          if (this.myChart !== null) {
            this.myChart.resize()
          }
        })
      },
      loadChart: function () {
        this.myChart = eCharts.init(document.getElementById(this.id), 'shine')
        this.options.radar.indicator = this.data.indicators
        this.options.series[0].data = this.data.series
        this.options.legend.data = this.data.series
        if (this.data.series.length === 1) {
          delete this.options['legend']
        }
        this.myChart.setOption(this.options)
        this.myChart.hideLoading()
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/custom/components/page/analyse/show/components/radar-config.vue